import { serviceRequest } from 'utils/http';
import { ReferralService, ProtocolInfoDto } from 'common/api';
import { ReferralStatusType } from 'global/referralStatus';

type UpdateReferralStatus = {
  id?: string;
  status: ReferralStatusType;
  appointmentDate?: string;
  protocolInfoDto?: ProtocolInfoDto;
  consentedDate?: string;
  isVisited: boolean;
  dropReasonId?: string;
};

export function updateReferralStatusAPI({
  id,
  status,
  appointmentDate,
  consentedDate,
  protocolInfoDto,
  isVisited,
  dropReasonId,
}: UpdateReferralStatus) {
  return serviceRequest(() =>
    ReferralService.referralControllerChangeStatusAsCurrentUser(id || '', {
      referralStatus: status as any,
      appointmentDateTime: appointmentDate,
      protocolInfoDto,
      consentedDate,
      isVisited,
      dropReasonId,
    })
  );
}
